@if (data) {
  <div class="icon">
    <span class="icon-circle">
      <mat-icon>check</mat-icon>
    </span>
  </div>
  <div class="content">
    <span class="title">{{ "SNACKBAR.SUCCESS" | translate }}</span>
    <p [innerHTML]="data | translate"></p>
  </div>
}
